import React from "react";
import PropTypes from "prop-types";

import { Box, makeStyles } from "@material-ui/core";
import Button from "../../../Button";
import {
  MAKE_MORE_CHANGES,
  RESET_ALL_CHANGES,
  SAVE_AND_EXIT,
  SAVE,
} from "../../../../constants/strings";
import palette from "../../../styles/palette";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.typography.pxToRem(10),
    "&:disabled": {
      opacity: 0.38,
    },
  },
}));

export const ScheduleRouteButtons = ({
  onSaveClick,
  onSaveAndExitClick,
  onResetClick,
  onMoreChangesClick,
  disabled,
  forceEnableResetAllChanges,
  isMakeMoreChanges,
}) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      {isMakeMoreChanges && (
        <Button
          bgColor={palette.yellow}
          color={palette.typography.black.solid}
          border={`1px solid ${palette.goldenGrass}`}
          onClick={onMoreChangesClick}
          className={classes.button}
          disabled={disabled}
        >
          {MAKE_MORE_CHANGES}
        </Button>
      )}
      <Button
        bgColor={palette.sunburst}
        color={palette.typography.white.solid}
        border={`1px solid ${palette.flamingo}`}
        className={classes.button}
        onClick={onResetClick}
        disabled={disabled && !forceEnableResetAllChanges}
      >
        {RESET_ALL_CHANGES}
      </Button>
      {isMakeMoreChanges && (
        <Button
          bgColor={palette.pictonBlue}
          color={palette.typography.white.solid}
          border={`1px solid ${palette.endeavour}`}
          className={classes.button}
          onClick={onSaveAndExitClick}
          disabled={disabled}
        >
          {SAVE_AND_EXIT}
        </Button>
      )}

      <Button
        bgColor={palette.pictonBlue}
        color={palette.typography.white.solid}
        border={`1px solid ${palette.endeavour}`}
        className={classes.button}
        onClick={onSaveClick}
        disabled={disabled}
      >
        {SAVE}
      </Button>
    </Box>
  );
};

ScheduleRouteButtons.propTypes = {
  onSaveClick: PropTypes.func.isRequired,
  onSaveAndExitClick: PropTypes.func.isRequired,
  onResetClick: PropTypes.func.isRequired,
  onMoreChangesClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};
